import React, { useState } from "react";
import { Tab, Grid } from "semantic-ui-react";
import Prescription from "features/FolderManager/components/Prescription";
import EditPrescription from "features/FolderManager/components/SidebarComp/EditPrescription";
import BlueButton from "components/Buttons/BlueButton";

const PrescriptionsContent = ({
	t,
	data,
	disabled,
	mode,
	role,
	generalParameters,
	folderManager,
	isMobile,
	folder,
	dualScreen,
	openScanOrdo,
	userIsSecretary,
	sendFilesToDualScreen,
	sendFullScanListToDualScreen,
	openSidebar,
	editPrescription,
	openPrescriptionScanModal,
	deletePrescription,
	hideSidebar,
	openGranteeModal,
	openContactModal,
	validationLoading,
	validateScanPrescription,
	validateQualityScanPrescription,
	unvalidateQualityScanPrescription,
	deleteScanPrescription,
	setPrescriptionScanBarcode,
	openEditPatient,
	tvSecScans,
	getScansForTVsecretariat,
	cleanScans,
	createFolderHelpAndQuit,
	updateScanPrescription,
	analysisLibrary,
	loadAllAnalysesAndPacks,
	postScanPrescription,
	getPrescriptionByBarcode,
	editAnalyses,
	getMatchingAnalyses,
	bulkAnalysesPrescription,
	groupByDocumentType,
	documentTypes,
	getAllDocumentTypes,
	getAllConsentRefusalReasons,
	consentRefusalReasons,
	postPhotoFolder,
	center,
	addAutoScanLogs,
	loadingScans,
	removeScanOrdo,
	useScanOrdo,
	getFPA,
	openQRReaderPrescriptionModal,
	openAddRepeatablePrescriptionModal,
	addPrescription,
	connectedSecretariesList,
	refuseAnalysis,
	isThemeHospital,
	refreshCenterScans,
	checkAnalysis,
	toggleContact,
}) => {
	const [isNewPrescription, setIsNewPrescription] = useState(true);
	const deletePresc = (prescription) => {
		setIsNewPrescription(false);
		deletePrescription(prescription, folder.id);
	};

	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			{data.prescriptions.map((elt, index) => (
				<Prescription
					prescription={elt}
					number={index + 1}
					folder={folder}
					openScanOrdo={openScanOrdo}
					patient={data.patient}
					generalParameters={generalParameters.data}
					dualScreen={dualScreen}
					onEdit={(e) => {
						if (e !== undefined) e.preventDefault();
						if (userIsSecretary) sendFilesToDualScreen(elt.scans);
						openSidebar(
							<EditPrescription
								prescription={elt}
								onSubmit={editPrescription}
								openPrescriptionScanModal={openPrescriptionScanModal}
								deletePrescription={deletePresc}
								hideSidebar={() => {
									hideSidebar();
									if (userIsSecretary) sendFullScanListToDualScreen();
								}}
								folder={folder}
								disabled={disabled}
								userIsSecretary={userIsSecretary}
								showPatientCard={data.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE && (data.prescriptions.length === 0 || userIsSecretary)}
								isSecretaryEditMode={mode === "edit"}
								patient={data.patient}
								dualScreen={dualScreen}
								generalParameters={generalParameters.data}
								openGranteeModal={openGranteeModal}
								validationLoading={validationLoading}
								validateScanPrescription={validateScanPrescription}
								validateQualityScanPrescription={validateQualityScanPrescription}
								unvalidateQualityScanPrescription={unvalidateQualityScanPrescription}
								deleteScanPrescription={deleteScanPrescription}
								submitBarCode={setPrescriptionScanBarcode}
								openEditPatient={(prescription) => openEditPatient(prescription, folder.prescriptions, disabled)}
								scans={tvSecScans}
								getScansForTVsecretariat={getScansForTVsecretariat}
								cleanScans={cleanScans}
								createFolderHelp={createFolderHelpAndQuit}
								openContactModal={openContactModal}
								getAllDocumentTypes={getAllDocumentTypes}
							/>
						);
					}}
					canAddAnalysis={data.infos.canAddAnalysis}
					role={role}
					analysisLibrary={analysisLibrary}
					loadAllAnalysesAndPacks={loadAllAnalysesAndPacks}
					postScanPrescription={postScanPrescription}
					editPrescription={editPrescription}
					deleteScanPrescription={deleteScanPrescription}
					getPrescriptionByBarcode={getPrescriptionByBarcode}
					bulkAnalysesPrescription={bulkAnalysesPrescription}
					getMatchingAnalyses={getMatchingAnalyses}
					createOrUpdateDoctor={getMatchingAnalyses}
					openSidebar={openSidebar}
					hideSidebar={hideSidebar}
					onAnalysesEditSubmit={editAnalyses}
					key={"prescription" + elt.id}
					isLoading={folderManager.analysisLoading}
					disabled={disabled}
					isHome={data.isHome}
					setPrescriptionScanBarcode={setPrescriptionScanBarcode}
					postFolderPhoto={postPhotoFolder}
					consentRefusalReasons={consentRefusalReasons}
					getAllConsentRefusalReasons={getAllConsentRefusalReasons}
					getAllDocumentTypes={getAllDocumentTypes}
					documentTypes={documentTypes}
					groupByDocumentType={groupByDocumentType}
					addAutoScanLogs={addAutoScanLogs}
					takePhotoModalOpen={isNewPrescription && index + 1 === data.prescriptions?.length}
					createFolderHelp={createFolderHelpAndQuit}
					center={center}
					getFPA={getFPA}
					validateScanPrescription={validateScanPrescription}
					validateQualityScanPrescription={validateQualityScanPrescription}
					unvalidateQualityScanPrescription={unvalidateQualityScanPrescription}
					submitBarCode={setPrescriptionScanBarcode}
					getScansForTVsecretariat={getScansForTVsecretariat}
					refreshCenterScans={refreshCenterScans}
					scans={tvSecScans}
					useScanOrdo={useScanOrdo}
					removeScanOrdo={removeScanOrdo}
					cleanScans={cleanScans}
					loadingScans={loadingScans}
					movePrescriptionScan={{
						active: !data.isDone && data.prescriptions?.length > 1,
						current: { p: elt, number: index + 1 },
						prescriptions: data.prescriptions.map((p, i) => {
							return { p: p, number: i + 1 };
						}),
						updateScanPrescription: updateScanPrescription,
					}}
					secretaries={connectedSecretariesList}
					refuseAnalysis={refuseAnalysis}
					isThemeHospital={isThemeHospital}
					isDeposit={!!data.deposit}
					checkAnalysis={checkAnalysis}
					toggleContact={toggleContact}
				/>
			))}

			{mode !== "validate" && !(isThemeHospital && data.prescriptions?.length > 0) && (
				<Grid style={{ marginTop: -15 }}>
					<Grid.Row style={{ margin: 0 }}>
						<Grid.Column
							mobile={16}
							tablet={5}
							computer={5}
							style={{
								justifyContent: isMobile() ? "center" : "flex-start",
								margin: isMobile() ? "0.5em 1rem" : "0",
							}}
						>
							<BlueButton
								style={{
									width: "100%",
									alignSlef: "center",
								}}
								text={t("folderManager.addPrescription")}
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									//Reset isNewPrescription
									setIsNewPrescription(false);
									openSidebar(
										<EditPrescription
											onSubmit={addPrescription}
											hideSidebar={hideSidebar}
											userIsSecretary={userIsSecretary}
											isSecretaryEditMode={mode === "edit"}
											disabled={disabled}
											folder={folder}
											patient={data.patient}
											dualScreen={dualScreen}
											showPatientCard={
												data.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE && (data.prescriptions.length === 0 || userIsSecretary)
											}
											generalParameters={generalParameters.data}
											openGranteeModal={openGranteeModal}
											validationLoading={validationLoading}
											openEditPatient={(prescription) => openEditPatient(prescription, data.folders[0].prescriptions, disabled)}
											scans={tvSecScans}
											getScansForTVsecretariat={getScansForTVsecretariat}
											cleanScans={cleanScans}
											createFolderHelp={createFolderHelpAndQuit}
											openContactModal={openContactModal}
											getAllDocumentTypes={getAllDocumentTypes}
										/>
									);
								}}
								disabled={disabled}
							/>
						</Grid.Column>
						<Grid.Column
							mobile={16}
							tablet={6}
							computer={6}
							style={{
								justifyContent: isMobile() ? "center" : "flex-start",
								margin: isMobile() ? "0.5em  1rem" : "0",
							}}
						>
							<BlueButton
								style={{
									width: "100%",
									alignSlef: "center",
								}}
								text={t("folderManager.importPrescription")}
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									openAddRepeatablePrescriptionModal();
								}}
								disabled={disabled}
							/>
						</Grid.Column>
						<Grid.Column
							mobile={16}
							tablet={5}
							computer={5}
							style={{
								justifyContent: isMobile() ? "center" : "flex-end",
								margin: isMobile() ? "0.5em  1rem" : "0",
							}}
						>
							<BlueButton
								style={{
									width: "100%",
									alignSlef: "center",
								}}
								text={t("folderManager.addEPrescription")}
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									openQRReaderPrescriptionModal();
								}}
								disabled={data.isDone}
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row
						columns={1}
						style={{
							marginTop: -15,
							marginBottom: 15,
							marginRight: isMobile() ? 10 : 0,
						}}
					></Grid.Row>
				</Grid>
			)}
		</Tab.Pane>
	);
};

export default PrescriptionsContent;
